import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SocialMediaContentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Campaign/CampaignBrowser")
	}

	render() {
		return (
			<Activity 
				name="SocialMediaContent"
				RenderedComponent={this.RenderedComponent}
                context="SocialMediaContent"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SocialMediaContentActivity)
